/* eslint-disable react/no-danger */
/* eslint-disable react/prop-types */
import React from 'react';
import { Typography, makeStyles } from '@material-ui/core';
// import { toPercent } from '../modules/text';

const ScatterTooltip = ({
  active, payload, label, valueFormatter, tooltipTemplate, primaryColor, formatterFunction,
}) => {
  const classes = makeStyles((theme) => ({
    paper: {
      padding: theme.spacing(2),
    },
    tooltip: {
      border: '1px solid',
      borderColor: primaryColor,
      textAlign: 'left',
      maxWidth: '250px',
      padding: '5px',
      font: '12px sans-serif',
      background: '#fff',
      zIndex: 20,
    },
  }))();

  if (active && payload) {
    const text = formatterFunction(payload[0]);
    return (
      <div className={classes.tooltip}>
        <Typography variant="body2" gutterBottom>
          <span dangerouslySetInnerHTML={{ __html: text }} />
        </Typography>

      </div>
    );
  }

  return null;
};

export default ScatterTooltip;
